<script lang="ts" setup>
import { ref } from 'vue'
import TakedownNoticeForm from '../components/forms/TakedownNoticeForm.vue'
import { useTakedownNoticeStore } from '../stores/takedown-notice-store'

const takedownNoticeStore = useTakedownNoticeStore()

const submitted = ref(false)
</script>

<template>
  <q-page padding class="layout-constrained">
    <div class="q-pa-md q-col-gutter-md">
      <div class="row">
        <div class="col-12">
          <div class="text-h6">Request removal of content</div>
          <p class="text-body1">
            Use this form to submit a request to remove content from the Road Footage platform under
            the Australian Copyright Act 1968. Your request will be reviewed before any action is
            taken.
          </p>
          <p class="text-body1">
            Access may be suspended if your request is determined to be illegitimate or malicious.
            False or misleading statements may result in legal action.
          </p>
          <p class="text-body1">
            Road Footage has no control over content uploaded to other platforms or otherwise shared
            to external entities.
          </p>
        </div>
      </div>

      <div class="row">
        <!-- Overview -->
        <div class="col">
          <q-card>
            <q-card-section>
              <takedown-notice-form
                v-show="!submitted"
                @save="submitted = true"
                @reset="takedownNoticeStore.$reset()"
              />
              <div v-show="submitted">
                <div class="text-h5">Your takendown notice has been submitted.</div>
                <div class="text-body1">Your request will be reviewed by our team.</div>
              </div>
            </q-card-section>
          </q-card>
        </div>
      </div>
    </div>
  </q-page>
</template>
